/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    readonly "/api/Addressing/matches": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly query?: string;
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": readonly components["schemas"]["Address"][];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example da5a651c-d696-41e8-84ac-1e54fdcde892 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Addressing/reverse": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly lat?: number;
                    readonly lon?: number;
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["Address"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Not Found */
                readonly 404: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example ea6e77a5-16af-4a6a-9d57-90c07694a882 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Availability/slots": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.Clinician"?: string;
                    readonly "sort.Clinician"?: components["schemas"]["SortDirection"];
                    readonly "filter.Location.LocationId"?: string;
                    readonly "filter.Location.Address.State"?: string;
                    readonly "filter.Location.distance"?: string;
                    readonly "sort.Location.distance"?: components["schemas"]["SortDirection"];
                    readonly "filter.Location"?: string;
                    readonly "sort.Location"?: components["schemas"]["SortDirection"];
                    readonly "filter.Days.Date"?: string;
                    readonly "filter.Days.DayOfWeek"?: string;
                    readonly "filter.Days.Slots.Time"?: string;
                    readonly "filter.Days.Slots.TimeOfDay"?: string;
                    readonly "filter.Days.Slots.Duration"?: string;
                    readonly "filter.Days.Slots.Setting"?: string;
                    readonly "filter.Days.Slots"?: string;
                    readonly "filter.Days"?: string;
                    readonly "sort.Days"?: components["schemas"]["SortDirection"];
                    readonly "filter.Clinician.gender"?: string;
                    readonly "sort.Clinician.gender"?: components["schemas"]["SortDirection"];
                    readonly "filter.Clinician.language"?: string;
                    readonly "sort.Clinician.language"?: components["schemas"]["SortDirection"];
                    readonly "filter.Clinician.npi"?: string;
                    readonly "sort.Clinician.npi"?: components["schemas"]["SortDirection"];
                    readonly "filter.Clinician.type"?: string;
                    readonly "sort.Clinician.type"?: components["schemas"]["SortDirection"];
                    readonly "filter.Clinician.supportedConditions"?: string;
                    readonly "sort.Clinician.supportedConditions"?: components["schemas"]["SortDirection"];
                    readonly "filter.Clinician.acceptedInsurance"?: string;
                    readonly "sort.Clinician.acceptedInsurance"?: components["schemas"]["SortDirection"];
                    readonly "filter.Clinician.acceptedInsurancePlans"?: string;
                    readonly "sort.Clinician.acceptedInsurancePlans"?: components["schemas"]["SortDirection"];
                    readonly "filter.Clinician.AgeRange"?: string;
                    readonly "sort.Clinician.AgeRange"?: components["schemas"]["SortDirection"];
                    readonly "filter.Clinician.id"?: string;
                    readonly "sort.Clinician.id"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ClinicianAvailabilityInfoIQueryResult"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example 99ef39c0-c4dc-4309-9337-a2f5c70dea6d */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Availability": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.ClinicianNpi"?: string;
                    readonly "sort.ClinicianNpi"?: components["schemas"]["SortDirection"];
                    readonly "filter.DateTime"?: string;
                    readonly "sort.DateTime"?: components["schemas"]["SortDirection"];
                    readonly "filter.Date"?: string;
                    readonly "sort.Date"?: components["schemas"]["SortDirection"];
                    readonly "filter.Time"?: string;
                    readonly "sort.Time"?: components["schemas"]["SortDirection"];
                    readonly "filter.LengthOfTime"?: string;
                    readonly "sort.LengthOfTime"?: components["schemas"]["SortDirection"];
                    readonly "filter.Setting"?: string;
                    readonly "sort.Setting"?: components["schemas"]["SortDirection"];
                    readonly "filter.location.address.state"?: string;
                    readonly "sort.location.address.state"?: components["schemas"]["SortDirection"];
                    readonly "filter.location.distance"?: string;
                    readonly "sort.location.distance"?: components["schemas"]["SortDirection"];
                    readonly "filter.location.Id"?: string;
                    readonly "sort.location.Id"?: components["schemas"]["SortDirection"];
                    readonly "filter.date.timeOfDay"?: string;
                    readonly "sort.date.timeOfDay"?: components["schemas"]["SortDirection"];
                    readonly "filter.date.dayOfWeek"?: string;
                    readonly "sort.date.dayOfWeek"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["AvailableAppointmentIQueryResult"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example eddd5e17-784c-4dd9-8a6e-9a1b3b5e701a */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Availability/info": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.ClinicianNpi"?: string;
                    readonly "sort.ClinicianNpi"?: components["schemas"]["SortDirection"];
                    readonly "filter.DateTime"?: string;
                    readonly "sort.DateTime"?: components["schemas"]["SortDirection"];
                    readonly "filter.Date"?: string;
                    readonly "sort.Date"?: components["schemas"]["SortDirection"];
                    readonly "filter.Time"?: string;
                    readonly "sort.Time"?: components["schemas"]["SortDirection"];
                    readonly "filter.LengthOfTime"?: string;
                    readonly "sort.LengthOfTime"?: components["schemas"]["SortDirection"];
                    readonly "filter.Setting"?: string;
                    readonly "sort.Setting"?: components["schemas"]["SortDirection"];
                    readonly "filter.location.address.state"?: string;
                    readonly "sort.location.address.state"?: components["schemas"]["SortDirection"];
                    readonly "filter.location.distance"?: string;
                    readonly "sort.location.distance"?: components["schemas"]["SortDirection"];
                    readonly "filter.location.Id"?: string;
                    readonly "sort.location.Id"?: components["schemas"]["SortDirection"];
                    readonly "filter.date.timeOfDay"?: string;
                    readonly "sort.date.timeOfDay"?: components["schemas"]["SortDirection"];
                    readonly "filter.date.dayOfWeek"?: string;
                    readonly "sort.date.dayOfWeek"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["AvailableAppointmentForInfoIQueryResult"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example d7306352-a55a-4c1d-8b92-3e70aa1cef41 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Batch": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get?: never;
        readonly put?: never;
        readonly post: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: {
                readonly content: {
                    readonly "application/json": {
                        readonly Clinicians: Readonly<Record<string, string>>;
                        readonly Clinics: Readonly<Record<string, string>>;
                        readonly Insurances: Readonly<Record<string, string>>;
                        readonly Reviews: Readonly<Record<string, string>>;
                        readonly Availability: Readonly<Record<string, string>>;
                    };
                    readonly "text/json": {
                        readonly Clinicians: Readonly<Record<string, string>>;
                        readonly Clinics: Readonly<Record<string, string>>;
                        readonly Insurances: Readonly<Record<string, string>>;
                        readonly Reviews: Readonly<Record<string, string>>;
                        readonly Availability: Readonly<Record<string, string>>;
                    };
                    readonly "application/*+json": {
                        readonly Clinicians: Readonly<Record<string, string>>;
                        readonly Clinics: Readonly<Record<string, string>>;
                        readonly Insurances: Readonly<Record<string, string>>;
                        readonly Reviews: Readonly<Record<string, string>>;
                        readonly Availability: Readonly<Record<string, string>>;
                    };
                };
            };
            readonly responses: {
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example b17c0cda-85ca-4716-88ea-83a0541b4f47 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Batch/{id}": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path: {
                    readonly id: string;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example a9d1f7de-1519-40a5-ac48-bf7c095fdc9a */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Batch/{id}/status": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path: {
                    readonly id: string;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example f0914f42-7f0c-46fe-a234-de0e965fe238 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Batch/{id}/resource/{requestedResource}": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path: {
                    readonly id: string;
                    readonly requestedResource: components["schemas"]["ResourceType"];
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example cc655453-23ff-4acb-b47a-d9098ffd5ad0 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Batch/presets/{presetName}": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get?: never;
        readonly put?: never;
        readonly post: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path: {
                    readonly presetName: string;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example d4e7c804-dacf-4585-9f3f-8efc84de759e */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Clinicians": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.NpiNumber"?: string;
                    readonly "sort.NpiNumber"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedAt"?: string;
                    readonly "sort.CreatedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedAt"?: string;
                    readonly "sort.ModifiedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedBy"?: string;
                    readonly "sort.ModifiedBy"?: components["schemas"]["SortDirection"];
                    readonly "filter.ContactDetails.FirstName"?: string;
                    readonly "filter.ContactDetails.LastName"?: string;
                    readonly "filter.Credentials"?: string;
                    readonly "sort.Credentials"?: components["schemas"]["SortDirection"];
                    readonly "filter.Title"?: string;
                    readonly "sort.Title"?: components["schemas"]["SortDirection"];
                    readonly "filter.Gender"?: string;
                    readonly "sort.Gender"?: components["schemas"]["SortDirection"];
                    readonly "filter.CredentialedDate"?: string;
                    readonly "sort.CredentialedDate"?: components["schemas"]["SortDirection"];
                    readonly "filter.StartDate"?: string;
                    readonly "sort.StartDate"?: components["schemas"]["SortDirection"];
                    readonly "filter.EndDate"?: string;
                    readonly "sort.EndDate"?: components["schemas"]["SortDirection"];
                    readonly "filter.DateOfBirth"?: string;
                    readonly "sort.DateOfBirth"?: components["schemas"]["SortDirection"];
                    readonly "filter.Active"?: string;
                    readonly "sort.Active"?: components["schemas"]["SortDirection"];
                    readonly "filter.AllowedInOnlineScheduling"?: string;
                    readonly "sort.AllowedInOnlineScheduling"?: components["schemas"]["SortDirection"];
                    readonly "filter.Education"?: string;
                    readonly "sort.Education"?: components["schemas"]["SortDirection"];
                    readonly "filter.ReviewStats.Average"?: string;
                    readonly "filter.ReviewStats"?: string;
                    readonly "sort.ReviewStats"?: components["schemas"]["SortDirection"];
                    readonly "filter.AgeRange.Min"?: string;
                    readonly "filter.AgeRange.Max"?: string;
                    readonly "filter.AgeRange"?: string;
                    readonly "sort.AgeRange"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ClinicianGeneralInfoIQueryResult"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example 246f69b1-726f-4296-ace6-defacdef7f1e */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Clinicians/{npi}": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path: {
                    readonly npi: number;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ClinicianDetailedInfo"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Not Found */
                readonly 404: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["NotFoundResult"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example 4b030234-83b0-430c-bec6-44b470bf3eb9 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Clinicians/{npi}/conditions": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.Id"?: string;
                    readonly "filter.Name"?: string;
                    readonly "sort.Name"?: components["schemas"]["SortDirection"];
                    readonly "filter.Description"?: string;
                    readonly "sort.Description"?: components["schemas"]["SortDirection"];
                    readonly "filter.ForTherapy"?: string;
                    readonly "sort.ForTherapy"?: components["schemas"]["SortDirection"];
                    readonly "filter.ForPrescriber"?: string;
                    readonly "sort.ForPrescriber"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsTherapyDefault"?: string;
                    readonly "sort.IsTherapyDefault"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsPrescriberDefault"?: string;
                    readonly "sort.IsPrescriberDefault"?: components["schemas"]["SortDirection"];
                    readonly "filter.InOnlineScheduling"?: string;
                    readonly "sort.InOnlineScheduling"?: components["schemas"]["SortDirection"];
                    readonly "filter.SortOrder"?: string;
                    readonly "sort.SortOrder"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsDeleted"?: string;
                    readonly "sort.IsDeleted"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedAt"?: string;
                    readonly "sort.CreatedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedBy"?: string;
                    readonly "sort.CreatedBy"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedAt"?: string;
                    readonly "sort.ModifiedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedBy"?: string;
                    readonly "sort.ModifiedBy"?: components["schemas"]["SortDirection"];
                    readonly "filter.clinicians.npinumber"?: string;
                    readonly "sort.clinicians.npinumber"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path: {
                    readonly npi: number;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ConditionIQueryResult"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example a1bde86e-aa18-4cd4-a480-9f3f879eb88c */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Clinicians/{npi}/locations": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.IsPrimaryLocation"?: string;
                    readonly "sort.IsPrimaryLocation"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsCredentialed"?: string;
                    readonly "sort.IsCredentialed"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsTreating"?: string;
                    readonly "sort.IsTreating"?: components["schemas"]["SortDirection"];
                    readonly "filter.StartDate"?: string;
                    readonly "sort.StartDate"?: components["schemas"]["SortDirection"];
                    readonly "filter.EndDate"?: string;
                    readonly "sort.EndDate"?: components["schemas"]["SortDirection"];
                    readonly "sort.LocationId"?: components["schemas"]["SortDirection"];
                    readonly "filter.SuppressFromWebsite"?: string;
                    readonly "sort.SuppressFromWebsite"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path: {
                    readonly npi: number;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["LocationIQueryResult"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example 6637c97b-3c7d-418d-bb0d-4f8aed6178f8 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Clinicians/{npi}/insurance": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.Id"?: string;
                    readonly "filter.Name"?: string;
                    readonly "sort.Name"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsTopInsurer"?: string;
                    readonly "sort.IsTopInsurer"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedAt"?: string;
                    readonly "sort.ModifiedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedBy"?: string;
                    readonly "sort.ModifiedBy"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsDeleted"?: string;
                    readonly "sort.IsDeleted"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedAt"?: string;
                    readonly "sort.CreatedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedBy"?: string;
                    readonly "sort.CreatedBy"?: components["schemas"]["SortDirection"];
                    readonly "filter.clinicians.npinumber"?: string;
                    readonly "sort.clinicians.npinumber"?: components["schemas"]["SortDirection"];
                    readonly "filter.state"?: string;
                    readonly "sort.state"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path: {
                    readonly npi: number;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["InsuranceIQueryResult"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example fcd53592-63c5-4e30-9e24-673a8d4e8ab0 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Clinicians/{npi}/availability": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.ClinicianNpi"?: string;
                    readonly "sort.ClinicianNpi"?: components["schemas"]["SortDirection"];
                    readonly "filter.DateTime"?: string;
                    readonly "sort.DateTime"?: components["schemas"]["SortDirection"];
                    readonly "filter.Date"?: string;
                    readonly "sort.Date"?: components["schemas"]["SortDirection"];
                    readonly "filter.Time"?: string;
                    readonly "sort.Time"?: components["schemas"]["SortDirection"];
                    readonly "filter.LengthOfTime"?: string;
                    readonly "sort.LengthOfTime"?: components["schemas"]["SortDirection"];
                    readonly "filter.Setting"?: string;
                    readonly "sort.Setting"?: components["schemas"]["SortDirection"];
                    readonly "filter.location.address.state"?: string;
                    readonly "sort.location.address.state"?: components["schemas"]["SortDirection"];
                    readonly "filter.location.distance"?: string;
                    readonly "sort.location.distance"?: components["schemas"]["SortDirection"];
                    readonly "filter.location.Id"?: string;
                    readonly "sort.location.Id"?: components["schemas"]["SortDirection"];
                    readonly "filter.date.timeOfDay"?: string;
                    readonly "sort.date.timeOfDay"?: components["schemas"]["SortDirection"];
                    readonly "filter.date.dayOfWeek"?: string;
                    readonly "sort.date.dayOfWeek"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path: {
                    readonly npi: number;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["AvailableAppointmentIQueryResult"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example ff8af6c2-0e5b-491e-b11c-9e741109cb74 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Clinicians/{npi}/reviews": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.Id"?: string;
                    readonly "sort.TargetId"?: components["schemas"]["SortDirection"];
                    readonly "filter.TargetType"?: string;
                    readonly "sort.TargetType"?: components["schemas"]["SortDirection"];
                    readonly "filter.Approver"?: string;
                    readonly "sort.Approver"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedAt"?: string;
                    readonly "sort.ModifiedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedBy"?: string;
                    readonly "sort.ModifiedBy"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsDeleted"?: string;
                    readonly "sort.IsDeleted"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedAt"?: string;
                    readonly "sort.CreatedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedBy"?: string;
                    readonly "sort.CreatedBy"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path: {
                    readonly npi: number;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ReviewIQueryResult"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example da840fe4-0dad-4d02-99fb-7488bff9df96 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Clinics": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.Location.BrandName"?: string;
                    readonly "filter.Location.Id"?: string;
                    readonly "filter.Location.Name"?: string;
                    readonly "filter.Location.SuppressFromWebsite"?: string;
                    readonly "filter.Location.ModifiedAt"?: string;
                    readonly "filter.Location.CreatedAt"?: string;
                    readonly "filter.Location.CreatedBy"?: string;
                    readonly "filter.Location"?: string;
                    readonly "sort.Location"?: components["schemas"]["SortDirection"];
                    readonly "filter.Attributes.SupportsTherapy"?: string;
                    readonly "filter.Attributes.SupportsMedMgmt"?: string;
                    readonly "filter.Attributes.HasEsketamine"?: string;
                    readonly "filter.Attributes.HasTms"?: string;
                    readonly "filter.Attributes.HasFlex"?: string;
                    readonly "filter.Attributes.HasGroupTherapy"?: string;
                    readonly "filter.Attributes"?: string;
                    readonly "sort.Attributes"?: components["schemas"]["SortDirection"];
                    readonly "filter.Email"?: string;
                    readonly "sort.Email"?: components["schemas"]["SortDirection"];
                    readonly "filter.Url"?: string;
                    readonly "sort.Url"?: components["schemas"]["SortDirection"];
                    readonly "filter.DescriptionHtml"?: string;
                    readonly "sort.DescriptionHtml"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedAt"?: string;
                    readonly "sort.CreatedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedBy"?: string;
                    readonly "sort.CreatedBy"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedAt"?: string;
                    readonly "sort.ModifiedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.SuppressFromWebsite"?: string;
                    readonly "sort.SuppressFromWebsite"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ClinicIQueryResult"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content?: never;
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Conditions": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.Id"?: string;
                    readonly "filter.Name"?: string;
                    readonly "sort.Name"?: components["schemas"]["SortDirection"];
                    readonly "filter.Description"?: string;
                    readonly "sort.Description"?: components["schemas"]["SortDirection"];
                    readonly "filter.ForTherapy"?: string;
                    readonly "sort.ForTherapy"?: components["schemas"]["SortDirection"];
                    readonly "filter.ForPrescriber"?: string;
                    readonly "sort.ForPrescriber"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsTherapyDefault"?: string;
                    readonly "sort.IsTherapyDefault"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsPrescriberDefault"?: string;
                    readonly "sort.IsPrescriberDefault"?: components["schemas"]["SortDirection"];
                    readonly "filter.InOnlineScheduling"?: string;
                    readonly "sort.InOnlineScheduling"?: components["schemas"]["SortDirection"];
                    readonly "filter.SortOrder"?: string;
                    readonly "sort.SortOrder"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsDeleted"?: string;
                    readonly "sort.IsDeleted"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedAt"?: string;
                    readonly "sort.CreatedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedBy"?: string;
                    readonly "sort.CreatedBy"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedAt"?: string;
                    readonly "sort.ModifiedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedBy"?: string;
                    readonly "sort.ModifiedBy"?: components["schemas"]["SortDirection"];
                    readonly "filter.clinicians.npinumber"?: string;
                    readonly "sort.clinicians.npinumber"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ConditionIQueryResult"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example bb6dfb43-21d7-43ee-9770-d69c667ce96d */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Conditions/{id}": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path: {
                    readonly id: number;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["Condition"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Not Found */
                readonly 404: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["NotFoundResult"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example 543c4264-7f06-4510-bfaa-0cb00162111a */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/intake/requests": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get?: never;
        readonly put?: never;
        readonly post: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: {
                readonly content: {
                    readonly "application/json": components["schemas"]["IntakeInitializationRequest"];
                    readonly "text/json": components["schemas"]["IntakeInitializationRequest"];
                    readonly "application/*+json": components["schemas"]["IntakeInitializationRequest"];
                };
            };
            readonly responses: {
                /** @description Created */
                readonly 201: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["IExposedIntakeRequestInfo"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example cb384123-7075-44e1-be34-f44ad3886ebb */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/intake/requests/{id}/availability": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path: {
                    readonly id: string;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content?: never;
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Not Found */
                readonly 404: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example cd41b3de-5b6f-48f3-adac-debb6e2bc537 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/intake/requests/{id}": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get?: never;
        readonly put: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path: {
                    readonly id: string;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: {
                readonly content: {
                    readonly "application/json": components["schemas"]["CheckInitializedIntakeRequest"];
                    readonly "text/json": components["schemas"]["CheckInitializedIntakeRequest"];
                    readonly "application/*+json": components["schemas"]["CheckInitializedIntakeRequest"];
                };
            };
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["IExposedIntakeRequestInfo"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Not Found */
                readonly 404: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example b6047183-99d2-41f0-974f-d5d1b7d9bbd0 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/intake/requests/{id}/hold": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get?: never;
        readonly put?: never;
        readonly post: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path: {
                    readonly id: string;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: {
                readonly content: {
                    readonly "application/json": components["schemas"]["IntakePatientReq"];
                    readonly "text/json": components["schemas"]["IntakePatientReq"];
                    readonly "application/*+json": components["schemas"]["IntakePatientReq"];
                };
            };
            readonly responses: {
                /** @description Created */
                readonly 201: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["FinalizedIntakeRequestInfo"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Not Found */
                readonly 404: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example 7bddce64-20c2-40df-9044-df6ac60e1efc */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Insurances": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.Plans.Id"?: string;
                    readonly "filter.Plans.InsuranceId"?: string;
                    readonly "filter.Plans.Name"?: string;
                    readonly "filter.Plans.State"?: string;
                    readonly "filter.Plans.ModifiedAt"?: string;
                    readonly "filter.Plans.ModifiedBy"?: string;
                    readonly "filter.Plans.IsDeleted"?: string;
                    readonly "filter.Plans.CreatedAt"?: string;
                    readonly "filter.Plans.CreatedBy"?: string;
                    readonly "filter.Plans.insurance.name"?: string;
                    readonly "sort.Plans.insurance.name"?: components["schemas"]["SortDirection"];
                    readonly "filter.Plans"?: string;
                    readonly "sort.Plans"?: components["schemas"]["SortDirection"];
                    readonly "filter.Id"?: string;
                    readonly "filter.Name"?: string;
                    readonly "sort.Name"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsTopInsurer"?: string;
                    readonly "sort.IsTopInsurer"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedAt"?: string;
                    readonly "sort.ModifiedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedBy"?: string;
                    readonly "sort.ModifiedBy"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsDeleted"?: string;
                    readonly "sort.IsDeleted"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedAt"?: string;
                    readonly "sort.CreatedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedBy"?: string;
                    readonly "sort.CreatedBy"?: components["schemas"]["SortDirection"];
                    readonly "filter.clinicians.npinumber"?: string;
                    readonly "sort.clinicians.npinumber"?: components["schemas"]["SortDirection"];
                    readonly "filter.state"?: string;
                    readonly "sort.state"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["DetailedInsuranceIQueryResult"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example b8fc3786-0a67-49f4-9445-1a0d07727d41 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Insurances/{id}": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path: {
                    readonly id: number;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["DetailedInsurance"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Not Found */
                readonly 404: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["NotFoundResult"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example f33ec782-f028-45a7-b0fc-1c90ef90239a */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Insurances/{id}/plans": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.Id"?: string;
                    readonly "filter.InsuranceId"?: string;
                    readonly "sort.InsuranceId"?: components["schemas"]["SortDirection"];
                    readonly "filter.Name"?: string;
                    readonly "sort.Name"?: components["schemas"]["SortDirection"];
                    readonly "filter.State"?: string;
                    readonly "sort.State"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedAt"?: string;
                    readonly "sort.ModifiedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedBy"?: string;
                    readonly "sort.ModifiedBy"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsDeleted"?: string;
                    readonly "sort.IsDeleted"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedAt"?: string;
                    readonly "sort.CreatedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedBy"?: string;
                    readonly "sort.CreatedBy"?: components["schemas"]["SortDirection"];
                    readonly "filter.insurance.name"?: string;
                    readonly "sort.insurance.name"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path: {
                    readonly id: number;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["InsurancePlanIQueryResult"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example fd1e4bb0-700f-4344-9c07-8bde61968dca */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Insurances/{id}/plans/{planId}": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path: {
                    readonly id: number;
                    readonly planId: number;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["InsurancePlan"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example fc0b2a3d-c580-4190-84a5-c4456f742375 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Locations": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.Location.BrandName"?: string;
                    readonly "filter.Location.Id"?: string;
                    readonly "filter.Location.Name"?: string;
                    readonly "filter.Location.SuppressFromWebsite"?: string;
                    readonly "filter.Location.ModifiedAt"?: string;
                    readonly "filter.Location.CreatedAt"?: string;
                    readonly "filter.Location.CreatedBy"?: string;
                    readonly "filter.Location"?: string;
                    readonly "sort.Location"?: components["schemas"]["SortDirection"];
                    readonly "filter.Attributes.SupportsTherapy"?: string;
                    readonly "filter.Attributes.SupportsMedMgmt"?: string;
                    readonly "filter.Attributes.HasEsketamine"?: string;
                    readonly "filter.Attributes.HasTms"?: string;
                    readonly "filter.Attributes.HasFlex"?: string;
                    readonly "filter.Attributes.HasGroupTherapy"?: string;
                    readonly "filter.Attributes"?: string;
                    readonly "sort.Attributes"?: components["schemas"]["SortDirection"];
                    readonly "filter.Email"?: string;
                    readonly "sort.Email"?: components["schemas"]["SortDirection"];
                    readonly "filter.Url"?: string;
                    readonly "sort.Url"?: components["schemas"]["SortDirection"];
                    readonly "filter.DescriptionHtml"?: string;
                    readonly "sort.DescriptionHtml"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedAt"?: string;
                    readonly "sort.CreatedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedBy"?: string;
                    readonly "sort.CreatedBy"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedAt"?: string;
                    readonly "sort.ModifiedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.SuppressFromWebsite"?: string;
                    readonly "sort.SuppressFromWebsite"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["LocationIQueryResult"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example 0044a8ab-3cad-4eff-a3ee-23f31acd22dc */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Locations/{id}": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path: {
                    readonly id: number;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["OldTenUpLocationInfo"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Not Found */
                readonly 404: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["NotFoundResult"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example 2d20e6c6-ac8a-4796-a876-89885da33cb8 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Locations/{id}/reviews": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.Id"?: string;
                    readonly "sort.TargetId"?: components["schemas"]["SortDirection"];
                    readonly "filter.TargetType"?: string;
                    readonly "sort.TargetType"?: components["schemas"]["SortDirection"];
                    readonly "filter.Approver"?: string;
                    readonly "sort.Approver"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedAt"?: string;
                    readonly "sort.ModifiedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedBy"?: string;
                    readonly "sort.ModifiedBy"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsDeleted"?: string;
                    readonly "sort.IsDeleted"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedAt"?: string;
                    readonly "sort.CreatedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedBy"?: string;
                    readonly "sort.CreatedBy"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path: {
                    readonly id: number;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ReviewIQueryResult"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example d4c2b359-c0b9-465c-9206-28f2bde29aeb */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Metadata": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.Category"?: string;
                    readonly "sort.Category"?: components["schemas"]["SortDirection"];
                    readonly "filter.Name"?: string;
                    readonly "sort.Name"?: components["schemas"]["SortDirection"];
                    readonly "filter.DataType"?: string;
                    readonly "sort.DataType"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsRequired"?: string;
                    readonly "sort.IsRequired"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsDeleted"?: string;
                    readonly "sort.IsDeleted"?: components["schemas"]["SortDirection"];
                    readonly "filter.Notes"?: string;
                    readonly "sort.Notes"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedAt"?: string;
                    readonly "sort.CreatedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.CreatedBy"?: string;
                    readonly "sort.CreatedBy"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedAt"?: string;
                    readonly "sort.ModifiedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.ModifiedBy"?: string;
                    readonly "sort.ModifiedBy"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["Metadata"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example 77f5d9e9-33aa-40e1-ad04-b363036a4e7b */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Patients": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly state?: components["schemas"]["State"];
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.ExternalId"?: string;
                    readonly "sort.CreatedAt"?: components["schemas"]["SortDirection"];
                    readonly "filter.DateOfBirth"?: string;
                    readonly "sort.DateOfBirth"?: components["schemas"]["SortDirection"];
                    readonly "filter.SexAtBirth"?: string;
                    readonly "sort.SexAtBirth"?: components["schemas"]["SortDirection"];
                    readonly "filter.PrimaryAddress.Address1"?: string;
                    readonly "filter.PrimaryAddress.Address2"?: string;
                    readonly "filter.PrimaryAddress.City"?: string;
                    readonly "filter.PrimaryAddress.State"?: string;
                    readonly "filter.PrimaryAddress.Zip"?: string;
                    readonly "filter.PrimaryAddress"?: string;
                    readonly "sort.PrimaryAddress"?: components["schemas"]["SortDirection"];
                    readonly "filter.ContactDetails.FirstName"?: string;
                    readonly "sort.ContactDetails.FirstName"?: components["schemas"]["SortDirection"];
                    readonly "filter.ContactDetails.LastName"?: string;
                    readonly "sort.ContactDetails.LastName"?: components["schemas"]["SortDirection"];
                    readonly "filter.ContactDetails.HomePhone"?: string;
                    readonly "sort.ContactDetails.HomePhone"?: components["schemas"]["SortDirection"];
                    readonly "filter.ContactDetails.MobilePhone"?: string;
                    readonly "sort.ContactDetails.MobilePhone"?: components["schemas"]["SortDirection"];
                    readonly "filter.ContactDetails.WorkPhone"?: string;
                    readonly "sort.ContactDetails.WorkPhone"?: components["schemas"]["SortDirection"];
                    readonly "filter.ContactDetails.Email"?: string;
                    readonly "sort.ContactDetails.Email"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["PatientIQueryResult"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example 3836737c-21b8-4961-8049-e99579b56789 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: {
                readonly content: {
                    readonly "application/json": components["schemas"]["CreatePatientReq"];
                    readonly "text/json": components["schemas"]["CreatePatientReq"];
                    readonly "application/*+json": components["schemas"]["CreatePatientReq"];
                };
            };
            readonly responses: {
                /** @description Created */
                readonly 201: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["Patient"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example 00171e86-298a-4557-b112-30f9709afc04 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Patients/{id}": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly id?: string;
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["Patient"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Not Found */
                readonly 404: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["NotFoundResult"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example 16456890-aaa1-47e3-b86a-270b7c49a484 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put: {
            readonly parameters: {
                readonly query: {
                    readonly id?: string;
                    readonly ExternalId: string;
                    readonly TermedOn?: string;
                    readonly IsActive: boolean;
                    readonly CreatedAt?: string;
                    readonly ClinicianNpi?: number;
                    readonly DateOfBirth: string;
                    readonly "ContactDetails.FirstName": string;
                    readonly "ContactDetails.LastName": string;
                    readonly "ContactDetails.Contactables"?: readonly components["schemas"]["IContactable"][];
                    readonly "ContactDetails.PhoneNumbers"?: readonly components["schemas"]["PhoneContact"][];
                    readonly "ContactDetails.Emails"?: readonly components["schemas"]["EmailContact"][];
                    readonly "ContactDetails.Addresses"?: readonly components["schemas"]["AddressContact"][];
                    readonly "ContactDetails.PrimaryAddress.Address1": string;
                    readonly "ContactDetails.PrimaryAddress.Address2"?: string;
                    readonly "ContactDetails.PrimaryAddress.City": string;
                    readonly "ContactDetails.PrimaryAddress.State": components["schemas"]["State"];
                    readonly "ContactDetails.PrimaryAddress.Zip": string;
                    readonly "ContactDetails.PrimaryAddress.Coordinates.Lat": number;
                    readonly "ContactDetails.PrimaryAddress.Coordinates.Long": number;
                    readonly "ContactDetails.PrimaryEmail"?: string;
                    readonly "ContactDetails.PrimaryPhone.Type"?: components["schemas"]["PhoneType"];
                    readonly "ContactDetails.PrimaryPhone.Number"?: string;
                    readonly "ContactDetails.PrimaryPhone.IsPrimary"?: boolean;
                    readonly "ContactDetails.PrimaryPhone.Id"?: number;
                    readonly "ContactDetails.PrimaryPhone.ContactableType"?: components["schemas"]["ContactType"];
                    readonly "ContactDetails.PrimaryPhone.Value"?: string;
                    readonly "ContactDetails.PrimaryPhone.Extension"?: string;
                    readonly SexAtBirth?: components["schemas"]["Gender"];
                    readonly "PrimaryAddress.Address1": string;
                    readonly "PrimaryAddress.Address2"?: string;
                    readonly "PrimaryAddress.City": string;
                    readonly "PrimaryAddress.State": components["schemas"]["State"];
                    readonly "PrimaryAddress.Zip": string;
                    readonly "PrimaryAddress.Coordinates.Lat": number;
                    readonly "PrimaryAddress.Coordinates.Long": number;
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description No Content */
                readonly 204: {
                    headers: Readonly<Record<string, unknown>>;
                    content?: never;
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example c519dc4e-857a-4847-a754-6a25855cc148 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly post?: never;
        readonly delete: {
            readonly parameters: {
                readonly query?: {
                    readonly id?: string;
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description No Content */
                readonly 204: {
                    headers: Readonly<Record<string, unknown>>;
                    content?: never;
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Not Found */
                readonly 404: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["NotFoundResult"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example be177a64-c829-4798-8da2-d3ea9f4ad6cb */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Patients/{id}/appointments": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly id?: string;
                    readonly Page?: number;
                    readonly PageSize?: number;
                    readonly "filter.Id"?: string;
                    readonly "sort.Id"?: components["schemas"]["SortDirection"];
                    readonly "filter.ExtClinicianId"?: string;
                    readonly "sort.ExtClinicianId"?: components["schemas"]["SortDirection"];
                    readonly "filter.ExtLocationId"?: string;
                    readonly "sort.ExtLocationId"?: components["schemas"]["SortDirection"];
                    readonly "filter.PatientId"?: string;
                    readonly "sort.PatientId"?: components["schemas"]["SortDirection"];
                    readonly "filter.Date"?: string;
                    readonly "sort.Date"?: components["schemas"]["SortDirection"];
                    readonly "filter.LengthOfTime"?: string;
                    readonly "sort.LengthOfTime"?: components["schemas"]["SortDirection"];
                    readonly "filter.Setting"?: string;
                    readonly "sort.Setting"?: components["schemas"]["SortDirection"];
                    readonly "filter.ClinicianNpi"?: string;
                    readonly "sort.ClinicianNpi"?: components["schemas"]["SortDirection"];
                    readonly "filter.IsDeleted"?: string;
                    readonly "sort.IsDeleted"?: components["schemas"]["SortDirection"];
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["AppointmentGeneralInfoIQueryResult"];
                    };
                };
                /** @description Bad Request */
                readonly 400: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ValidationProblemDetails"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example baa0cded-bf92-41d5-b5d5-57de60aa4985 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post: {
            readonly parameters: {
                readonly query?: {
                    readonly id?: string;
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: {
                readonly content: {
                    readonly "application/json": components["schemas"]["AvailableAppointment"];
                    readonly "text/json": components["schemas"]["AvailableAppointment"];
                    readonly "application/*+json": components["schemas"]["AvailableAppointment"];
                };
            };
            readonly responses: {
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example a856df25-1979-428b-b343-f0e9ce9ec2f1 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/Patients/{id}/appointments/{apptId}": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    readonly id?: string;
                    readonly apptId?: string;
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["AppointmentGeneralInfo"];
                    };
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Not Found */
                readonly 404: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["NotFoundResult"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example ae596576-b4ae-4bce-90ed-0c6e241f5613 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete: {
            readonly parameters: {
                readonly query?: {
                    readonly id?: string;
                    readonly apptId?: string;
                };
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description No Content */
                readonly 204: {
                    headers: Readonly<Record<string, unknown>>;
                    content?: never;
                };
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Not Found */
                readonly 404: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["NotFoundResult"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": {
                            /** @example MPH0000 */
                            readonly code: string;
                            /** @example Unknown Exception */
                            readonly message: string;
                            /** @example 500 */
                            readonly statusCode: number;
                            /** @example 4b610b06-62ef-48bf-95d9-41ee18a9f5f5 */
                            readonly traceId: string;
                            readonly data: Record<string, never>;
                        };
                    };
                };
            };
        };
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description OK */
                readonly 200: {
                    headers: Readonly<Record<string, unknown>>;
                    content?: never;
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/system/health": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content?: never;
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete?: never;
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/system/cache": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content?: never;
                };
            };
        };
        readonly put?: never;
        readonly post?: never;
        readonly delete: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path?: never;
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content?: never;
                };
            };
        };
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
    readonly "/api/system/cache/{key}": {
        readonly parameters: {
            readonly query?: never;
            readonly header?: never;
            readonly path?: never;
            readonly cookie?: never;
        };
        readonly get?: never;
        readonly put?: never;
        readonly post?: never;
        readonly delete: {
            readonly parameters: {
                readonly query?: never;
                readonly header?: never;
                readonly path: {
                    readonly key: string;
                };
                readonly cookie?: never;
            };
            readonly requestBody?: never;
            readonly responses: {
                /** @description Unauthorized */
                readonly 401: {
                    headers: Readonly<Record<string, unknown>>;
                    content: {
                        readonly "application/json": components["schemas"]["ProblemDetails"];
                    };
                };
                /** @description Internal Server Error */
                readonly 500: {
                    headers: Readonly<Record<string, unknown>>;
                    content?: never;
                };
            };
        };
        readonly options?: never;
        readonly head?: never;
        readonly patch?: never;
        readonly trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        readonly Address: {
            readonly address1: string;
            readonly address2?: string | null;
            readonly city: string;
            readonly state: components["schemas"]["State"];
            readonly zip: string;
            readonly coordinates?: components["schemas"]["Coordinates"];
        };
        readonly AddressContact: {
            readonly address: components["schemas"]["Address"];
            readonly isPrimary?: boolean;
            /** Format: int32 */
            readonly id?: number | null;
            readonly contactableType: components["schemas"]["ContactType"];
        };
        readonly AppointmentGeneralInfo: {
            readonly id: string;
            readonly extClinicianId: string;
            readonly extLocationId: string;
            readonly patientId: string;
            /** Format: date */
            readonly date: string;
            /** Format: time */
            readonly time: string;
            /** Format: int32 */
            readonly lengthOfTime: number;
            readonly setting: components["schemas"]["AppointmentSettingType"];
            /** Format: int32 */
            readonly clinicianNpi: number;
            readonly status: components["schemas"]["AppointmentStatus"];
            readonly isHold: boolean;
            readonly isDeleted: boolean;
        };
        readonly AppointmentGeneralInfoIQueryResult: {
            /** Format: int32 */
            readonly totalCount: number;
            /** Format: int32 */
            readonly totalPages: number;
            /** Format: int32 */
            readonly currentPage: number;
            /** Format: int32 */
            readonly itemsInPageCount: number;
            readonly hasMore: boolean;
            readonly items: readonly components["schemas"]["AppointmentGeneralInfo"][];
        };
        /** @enum {string} */
        readonly AppointmentSettingType: AppointmentSettingType;
        /** @enum {string} */
        readonly AppointmentStatus: AppointmentStatus;
        readonly AttachmentExposedInfo: {
            readonly side: components["schemas"]["IntakeAttachmentSide"];
            readonly forPrimary: boolean;
        };
        readonly AttachmentExposedInfoIExposedIntakeRequestInfo: {
            /** Format: int64 */
            readonly expiresAt: number;
            readonly token: string | null;
            /** Format: uuid */
            readonly id: string;
            readonly data: components["schemas"]["AttachmentExposedInfo"];
        };
        readonly AvailableAppointment: {
            /** Format: int32 */
            readonly clinicianNpi: number;
            readonly location?: components["schemas"]["Location"];
            /** Format: date-time */
            readonly date?: string;
            /** Format: int32 */
            readonly lengthOfTime: number;
            readonly setting: components["schemas"]["AppointmentSettingType"];
        };
        readonly AvailableAppointmentForInfo: {
            /** Format: int32 */
            readonly clinicianNpi: number;
            /** Format: int32 */
            readonly locationId: number;
        };
        readonly AvailableAppointmentForInfoIQueryResult: {
            /** Format: int32 */
            readonly totalCount: number;
            /** Format: int32 */
            readonly totalPages: number;
            /** Format: int32 */
            readonly currentPage: number;
            /** Format: int32 */
            readonly itemsInPageCount: number;
            readonly hasMore: boolean;
            readonly items: readonly components["schemas"]["AvailableAppointmentForInfo"][];
        };
        readonly AvailableAppointmentIQueryResult: {
            /** Format: int32 */
            readonly totalCount: number;
            /** Format: int32 */
            readonly totalPages: number;
            /** Format: int32 */
            readonly currentPage: number;
            /** Format: int32 */
            readonly itemsInPageCount: number;
            readonly hasMore: boolean;
            readonly items: readonly components["schemas"]["AvailableAppointment"][];
        };
        /** @enum {string} */
        readonly BookingStatusType: BookingStatusType;
        readonly BusinessHours: {
            readonly day: components["schemas"]["Day"];
            /** Format: time */
            readonly open?: string;
            /** Format: time */
            readonly close?: string;
        };
        readonly CheckInitializedIntakeRequest: {
            /** Format: uuid */
            readonly id: string;
            readonly patient: components["schemas"]["PatientBase"];
            readonly appointment: components["schemas"]["IntakeAppointmentInfo"];
            readonly insurances?: readonly components["schemas"]["InsuranceInfo"][];
            readonly reason: components["schemas"]["ReasonInfo"];
            readonly otpCode?: string | null;
        };
        readonly Clinic: {
            readonly location: components["schemas"]["Location"];
            readonly businessHours?: readonly components["schemas"]["BusinessHours"][];
            readonly attributes: components["schemas"]["ClinicalLocationAttributes"];
            readonly email: string | null;
            readonly url: string | null;
            readonly descriptionHtml: string | null;
            /** Format: date-time */
            readonly createdAt: string;
            readonly createdBy: string;
            /** Format: date-time */
            readonly modifiedAt: string | null;
        };
        readonly ClinicIQueryResult: {
            /** Format: int32 */
            readonly totalCount: number;
            /** Format: int32 */
            readonly totalPages: number;
            /** Format: int32 */
            readonly currentPage: number;
            /** Format: int32 */
            readonly itemsInPageCount: number;
            readonly hasMore: boolean;
            readonly items: readonly components["schemas"]["Clinic"][];
        };
        readonly ClinicalLocationAttributes: {
            readonly supportsTherapy: boolean;
            readonly supportsMedMgmt: boolean;
            readonly hasEsketamine: boolean;
            readonly hasTms: boolean;
            readonly hasFlex: boolean;
            readonly hasGroupTherapy: boolean;
        };
        readonly ClinicianAvailabilityInfo: {
            readonly clinician: components["schemas"]["ClinicianInfo"];
            readonly location: components["schemas"]["LocationInfo"];
            readonly days: readonly components["schemas"]["DaySlot"][];
        };
        readonly ClinicianAvailabilityInfoIQueryResult: {
            /** Format: int32 */
            readonly totalCount: number;
            /** Format: int32 */
            readonly totalPages: number;
            /** Format: int32 */
            readonly currentPage: number;
            /** Format: int32 */
            readonly itemsInPageCount: number;
            readonly hasMore: boolean;
            readonly items: readonly components["schemas"]["ClinicianAvailabilityInfo"][];
        };
        readonly ClinicianDetailedInfo: {
            /** Format: int32 */
            readonly id: number;
            /** Format: int32 */
            readonly npiNumber: number;
            /** Format: date-time */
            readonly createdAt: string;
            readonly createdBy: string;
            /** Format: int32 */
            readonly primaryLocationId: number | null;
            /** Format: date-time */
            readonly modifiedAt?: string | null;
            readonly modifiedBy?: string | null;
            readonly type: components["schemas"]["ClinicianType"];
            readonly contactDetails: components["schemas"]["ContactDetails"];
            readonly credentials: string;
            readonly title: string;
            readonly photoUrl?: string | null;
            readonly gender: components["schemas"]["Gender"];
            readonly bio: string;
            readonly notes?: string | null;
            /** Format: date */
            readonly credentialedDate: string | null;
            /** Format: date */
            readonly startDate: string | null;
            /** Format: date */
            readonly endDate: string | null;
            /** Format: date-time */
            readonly dateOfBirth: string | null;
            readonly active: boolean;
            readonly allowedInOnlineScheduling: boolean;
            readonly education: string;
            readonly reviewStats?: components["schemas"]["ReviewStats"];
            readonly ageRange: components["schemas"]["Int32RangedValue"];
            readonly isDeleted?: boolean;
            readonly locations: readonly components["schemas"]["ClinicianLocationInfo"][];
            readonly acceptedInsuranceIds: readonly number[];
            readonly supportedConditionIds: readonly number[];
            readonly languages: readonly string[];
        };
        readonly ClinicianGeneralInfo: {
            /** Format: int32 */
            readonly id: number;
            /** Format: int32 */
            readonly npiNumber: number;
            /** Format: date-time */
            readonly createdAt: string;
            readonly createdBy: string;
            /** Format: int32 */
            readonly primaryLocationId: number | null;
            /** Format: date-time */
            readonly modifiedAt?: string | null;
            readonly modifiedBy?: string | null;
            readonly type: components["schemas"]["ClinicianType"];
            readonly contactDetails: components["schemas"]["ContactDetails"];
            readonly credentials: string;
            readonly title: string;
            readonly photoUrl?: string | null;
            readonly gender: components["schemas"]["Gender"];
            readonly bio: string;
            readonly notes?: string | null;
            /** Format: date */
            readonly credentialedDate: string | null;
            /** Format: date */
            readonly startDate: string | null;
            /** Format: date */
            readonly endDate: string | null;
            /** Format: date-time */
            readonly dateOfBirth: string | null;
            readonly active: boolean;
            readonly allowedInOnlineScheduling: boolean;
            readonly education: string;
            readonly reviewStats?: components["schemas"]["ReviewStats"];
            readonly ageRange: components["schemas"]["Int32RangedValue"];
            readonly isDeleted?: boolean;
        };
        readonly ClinicianGeneralInfoIQueryResult: {
            /** Format: int32 */
            readonly totalCount: number;
            /** Format: int32 */
            readonly totalPages: number;
            /** Format: int32 */
            readonly currentPage: number;
            /** Format: int32 */
            readonly itemsInPageCount: number;
            readonly hasMore: boolean;
            readonly items: readonly components["schemas"]["ClinicianGeneralInfo"][];
        };
        readonly ClinicianInfo: {
            readonly type: components["schemas"]["ClinicianType"];
            readonly contactDetails: components["schemas"]["ContactDetails"];
            readonly externalId: string;
            /** Format: int32 */
            readonly id: number;
            /** Format: int32 */
            readonly npi: number;
        };
        readonly ClinicianLocationInfo: {
            readonly isPrimaryLocation: boolean;
            readonly isCredentialed: boolean;
            readonly isTreating: boolean;
            /** Format: date */
            readonly startDate: string | null;
            /** Format: date */
            readonly endDate: string | null;
            readonly notes?: string | null;
            /** Format: int32 */
            readonly locationId: number;
            readonly metadata: components["schemas"]["ClinicianLocationMetadata"];
            readonly createdBy: string;
            /** Format: date-time */
            readonly createdAt: string;
            readonly modifiedBy?: string | null;
            /** Format: date-time */
            readonly modifiedAt?: string | null;
        };
        readonly ClinicianLocationMetadata: {
            readonly categories: Readonly<Record<string, Readonly<Record<string, unknown>>>>;
        };
        /** @enum {string} */
        readonly ClinicianType: ClinicianType;
        readonly Condition: {
            /** Format: int32 */
            readonly id: number;
            readonly name: string;
            readonly description: string;
            readonly forTherapy?: boolean;
            readonly forPrescriber?: boolean;
            readonly isTherapyDefault?: boolean;
            readonly isPrescriberDefault?: boolean;
            readonly inOnlineScheduling?: boolean;
            /** Format: int32 */
            readonly sortOrder?: number;
            readonly isPinned?: boolean;
            readonly isDeleted?: boolean;
            /** Format: date-time */
            readonly createdAt: string;
            readonly createdBy: string;
            /** Format: date-time */
            readonly modifiedAt?: string | null;
            readonly modifiedBy?: string | null;
        };
        readonly ConditionIQueryResult: {
            /** Format: int32 */
            readonly totalCount: number;
            /** Format: int32 */
            readonly totalPages: number;
            /** Format: int32 */
            readonly currentPage: number;
            /** Format: int32 */
            readonly itemsInPageCount: number;
            readonly hasMore: boolean;
            readonly items: readonly components["schemas"]["Condition"][];
        };
        readonly ContactDetails: {
            readonly firstName: string;
            readonly lastName: string;
            readonly contactables?: readonly components["schemas"]["IContactable"][];
            readonly phoneNumbers?: readonly components["schemas"]["PhoneContact"][];
            readonly emails?: readonly components["schemas"]["EmailContact"][];
            readonly addresses?: readonly components["schemas"]["AddressContact"][];
        };
        /** @enum {string} */
        readonly ContactType: ContactType;
        readonly Coordinates: {
            /** Format: double */
            readonly lat: number;
            /** Format: double */
            readonly long: number;
        };
        readonly CreatePatientReq: {
            readonly patient: components["schemas"]["PatientBase"];
            readonly clinicianId?: string;
            readonly notes?: string | null;
        };
        /** @enum {string} */
        readonly Day: Day;
        readonly DaySlot: {
            /** Format: date */
            readonly date: string;
            readonly dayOfWeek: components["schemas"]["Day"];
            readonly slots?: readonly components["schemas"]["TimeSlot"][];
        };
        readonly DetailedInsurance: {
            /** Format: int32 */
            readonly id: number;
            readonly name: string;
            readonly logoUrl: string | null;
            readonly isTopInsurer: boolean;
            /** Format: date-time */
            readonly modifiedAt?: string | null;
            readonly modifiedBy?: string | null;
            readonly isDeleted?: boolean;
            /** Format: date-time */
            readonly createdAt: string;
            readonly createdBy: string;
            readonly plans: readonly components["schemas"]["InsurancePlan"][];
        };
        readonly DetailedInsuranceIQueryResult: {
            /** Format: int32 */
            readonly totalCount: number;
            /** Format: int32 */
            readonly totalPages: number;
            /** Format: int32 */
            readonly currentPage: number;
            /** Format: int32 */
            readonly itemsInPageCount: number;
            readonly hasMore: boolean;
            readonly items: readonly components["schemas"]["DetailedInsurance"][];
        };
        readonly EmailContact: {
            readonly address?: string;
            readonly isPrimary?: boolean;
            /** Format: int32 */
            readonly id?: number | null;
            readonly contactableType: components["schemas"]["ContactType"];
        };
        readonly FinalizedIntakeRequestInfo: {
            readonly attachments: readonly components["schemas"]["AttachmentExposedInfoIExposedIntakeRequestInfo"][];
            readonly formsLink?: string | null;
        };
        /** @enum {string} */
        readonly Gender: Gender;
        readonly IContactable: {
            /** Format: int32 */
            readonly id?: number | null;
            readonly contactableType: components["schemas"]["ContactType"];
            readonly value?: string;
            readonly isPrimary?: boolean;
        };
        readonly IExposedIntakeRequestInfo: {
            /** Format: int64 */
            readonly expiresAt: number;
            readonly token: string;
            /** Format: uuid */
            readonly id: `${string}-${string}-${string}-${string}`
        };
        readonly Insurance: {
            /** Format: int32 */
            readonly id: number;
            readonly name: string;
            readonly logoUrl: string | null;
            readonly isTopInsurer: boolean;
            /** Format: date-time */
            readonly modifiedAt?: string | null;
            readonly modifiedBy?: string | null;
            readonly isDeleted?: boolean;
            /** Format: date-time */
            readonly createdAt: string;
            readonly createdBy: string;
        };
        readonly InsuranceIQueryResult: {
            /** Format: int32 */
            readonly totalCount: number;
            /** Format: int32 */
            readonly totalPages: number;
            /** Format: int32 */
            readonly currentPage: number;
            /** Format: int32 */
            readonly itemsInPageCount: number;
            readonly hasMore: boolean;
            readonly items: readonly components["schemas"]["Insurance"][];
        };
        readonly InsuranceInfo: {
            /** Format: int32 */
            readonly insuranceId: number;
            /** Format: int32 */
            readonly planId: number;
            readonly memberId: string;
            readonly cashSelfPayAttested?: boolean|null;
            readonly groupNumber?: string | null;
            readonly isNotPolicyHolder?: boolean;
            readonly holderFullName?: string | null;
            /** Format: date */
            readonly holderDateOfBirth?: string | null;
            readonly isPrimary?: boolean;
        };
        readonly InsurancePlan: {
            /** Format: int32 */
            readonly id: number;
            /** Format: int32 */
            readonly insuranceId: number;
            readonly name: string;
            readonly state: components["schemas"]["State"];
            /** Format: date-time */
            readonly modifiedAt?: string | null;
            readonly modifiedBy?: string | null;
            readonly isDeleted?: boolean;
            readonly isTopPlan?: boolean;
            readonly isPinned?: boolean;
            readonly bookingStatusId: components["schemas"]["BookingStatusType"];
            /** Format: date-time */
            readonly createdAt: string;
            readonly createdBy: string;
        };
        readonly InsurancePlanIQueryResult: {
            /** Format: int32 */
            readonly totalCount: number;
            /** Format: int32 */
            readonly totalPages: number;
            /** Format: int32 */
            readonly currentPage: number;
            /** Format: int32 */
            readonly itemsInPageCount: number;
            readonly hasMore: boolean;
            readonly items: readonly components["schemas"]["InsurancePlan"][];
        };
        readonly Int32RangedValue: {
            /** Format: int32 */
            readonly min: number;
            /** Format: int32 */
            readonly max: number;
        };
        readonly IntakeAppointmentInfo: {
            /** Format: int32 */
            readonly id: number;
            /** Format: date */
            readonly date: string;
            /** Format: time */
            readonly time: string;
            /** Format: int32 */
            readonly clinicianId: number;
            /** Format: int32 */
            readonly locationId: number;
            /** Format: int32 */
            readonly duration: number;
            readonly setting: components["schemas"]["AppointmentSettingType"];
        };
        /** @enum {string} */
        readonly IntakeAttachmentSide: IntakeAttachmentSide;
        readonly IntakeInitializationRequest: {
            readonly otpTarget: components["schemas"]["NotificationType"];
            readonly patient: components["schemas"]["PatientBase"];
            readonly manualOtpDestination?: string | null;
            readonly otpDestination?: string;
        };
        readonly IntakePatientReq: {
            /** Format: uuid */
            readonly id: string;
            readonly patient: components["schemas"]["PatientBase"];
            readonly appointment: components["schemas"]["IntakeAppointmentInfo"];
            readonly insurances?: readonly components["schemas"]["InsuranceInfo"][];
            readonly reason: components["schemas"]["ReasonInfo"];
        };
        readonly Location: {
            readonly brandName: string;
            /** Format: int32 */
            readonly id: number;
            readonly address: components["schemas"]["Address"];
            readonly name: string;
            readonly shortName: string;
            readonly type: components["schemas"]["LocationType"];
            /** Format: int32 */
            readonly regionId?: number;
            /** Format: int32 */
            readonly marketId?: number;
            readonly notes?: string | null;
            readonly status: string;
            readonly suppressFromWebsite: boolean;
            readonly phoneNumber?: components["schemas"]["PhoneContact"];
            readonly faxNumber?: components["schemas"]["PhoneContact"];
            /** Format: date-time */
            readonly modifiedAt: string;
            /** Format: date-time */
            readonly createdAt: string;
            readonly createdBy: string;
        };
        readonly LocationIQueryResult: {
            /** Format: int32 */
            readonly totalCount: number;
            /** Format: int32 */
            readonly totalPages: number;
            /** Format: int32 */
            readonly currentPage: number;
            /** Format: int32 */
            readonly itemsInPageCount: number;
            readonly hasMore: boolean;
            readonly items: readonly components["schemas"]["Location"][];
        };
        readonly LocationInfo: {
            readonly externalLocationId: string;
            /** Format: int32 */
            readonly locationId: number;
            readonly address: components["schemas"]["Address"];
            readonly emailAddress: string;
            readonly phoneNumber: string;
        };
        /** @enum {string} */
        readonly LocationType: LocationType;
        readonly Metadata: {
            /** Format: int32 */
            readonly id: number;
            readonly category: string;
            readonly name: string;
            readonly dataType: components["schemas"]["Type"];
            readonly isRequired: boolean;
            readonly isDeleted: boolean;
            readonly notes?: string | null;
            /** Format: date-time */
            readonly createdAt: string;
            readonly createdBy: string;
            /** Format: date-time */
            readonly modifiedAt?: string | null;
            readonly modifiedBy?: string | null;
        };
        readonly NotFoundResult: {
            /** Format: int32 */
            readonly statusCode: number;
        };
        /** @enum {string} */
        readonly NotificationType: NotificationType;
        readonly OldTenUpLocationInfo: {
            /** Format: int32 */
            readonly id?: number;
            readonly address: components["schemas"]["Address"];
            readonly name?: string;
            readonly suppressFromWebsite?: boolean;
            readonly shortName?: string;
            readonly brandName?: string;
            readonly businessHours?: readonly components["schemas"]["BusinessHours"][];
            readonly contactables?: readonly components["schemas"]["IContactable"][];
            readonly isDeleted?: boolean;
            /** Format: date-time */
            readonly modifiedAt?: string | null;
            /** Format: date-time */
            readonly createdAt?: string;
            readonly attributes: components["schemas"]["ClinicalLocationAttributes"];
            readonly descriptionHtml?: string | null;
        };
        readonly Patient: {
            /** Format: int32 */
            readonly clinicianNpi?: number;
            /** Format: date */
            readonly dateOfBirth: string;
            readonly contactDetails: components["schemas"]["ContactDetails"];
            readonly sexAtBirth: components["schemas"]["Gender"];
            readonly externalId: string;
            /** Format: date-time */
            readonly termedOn?: string | null;
            readonly isActive: boolean;
            /** Format: date-time */
            readonly createdAt?: string;
        };
        readonly PatientBase: {
            readonly externalId?: string | null;
            /** Format: int32 */
            readonly clinicianNpi?: number;
            /** Format: date */
            readonly dateOfBirth: string;
            readonly contactDetails: components["schemas"]["ContactDetails"];
            readonly sexAtBirth: components["schemas"]["Gender"];
        };
        readonly PatientIQueryResult: {
            /** Format: int32 */
            readonly totalCount: number;
            /** Format: int32 */
            readonly totalPages: number;
            /** Format: int32 */
            readonly currentPage: number;
            /** Format: int32 */
            readonly itemsInPageCount: number;
            readonly hasMore: boolean;
            readonly items: readonly components["schemas"]["Patient"][];
        };
        readonly PhoneContact: {
            readonly type: components["schemas"]["PhoneType"];
            readonly number?: string;
            readonly isPrimary?: boolean;
            /** Format: int32 */
            readonly id?: number | null;
            readonly contactableType: components["schemas"]["ContactType"];
            readonly extension?: string | null;
        };
        /** @enum {string} */
        readonly PhoneType: PhoneType;
        readonly ProblemDetails: {
            readonly type: string | null;
            readonly title: string | null;
            /** Format: int32 */
            readonly status: number | null;
            readonly detail: string | null;
            readonly instance: string | null;
        } & Readonly<Record<string, unknown>>;
        /** Query<AppointmentGeneralInfo> */
        readonly "Query<AppointmentGeneralInfo>": {
            /**
             * Format: int32
             * @default 1
             */
            readonly Page: number;
            /**
             * Format: int32
             * @default 100
             */
            readonly PageSize: number;
            readonly "filter.Id": string;
            readonly "sort.Id": components["schemas"]["SortDirection"];
            readonly "filter.ExtClinicianId": string;
            readonly "sort.ExtClinicianId": components["schemas"]["SortDirection"];
            readonly "filter.ExtLocationId": string;
            readonly "sort.ExtLocationId": components["schemas"]["SortDirection"];
            readonly "filter.PatientId": string;
            readonly "sort.PatientId": components["schemas"]["SortDirection"];
            readonly "filter.Date": string;
            readonly "sort.Date": components["schemas"]["SortDirection"];
            readonly "filter.LengthOfTime": string;
            readonly "sort.LengthOfTime": components["schemas"]["SortDirection"];
            readonly "filter.Setting": string;
            readonly "sort.Setting": components["schemas"]["SortDirection"];
            readonly "filter.ClinicianNpi": string;
            readonly "sort.ClinicianNpi": components["schemas"]["SortDirection"];
            readonly "filter.IsDeleted": string;
            readonly "sort.IsDeleted": components["schemas"]["SortDirection"];
        };
        /** Query<AvailableAppointment> */
        readonly "Query<AvailableAppointment>": {
            /**
             * Format: int32
             * @default 1
             */
            readonly Page: number;
            /**
             * Format: int32
             * @default 100
             */
            readonly PageSize: number;
            readonly "filter.ClinicianNpi": string;
            readonly "sort.ClinicianNpi": components["schemas"]["SortDirection"];
            readonly "filter.DateTime": string;
            readonly "sort.DateTime": components["schemas"]["SortDirection"];
            readonly "filter.Date": string;
            readonly "sort.Date": components["schemas"]["SortDirection"];
            readonly "filter.Time": string;
            readonly "sort.Time": components["schemas"]["SortDirection"];
            readonly "filter.LengthOfTime": string;
            readonly "sort.LengthOfTime": components["schemas"]["SortDirection"];
            readonly "filter.Setting": string;
            readonly "sort.Setting": components["schemas"]["SortDirection"];
            readonly "filter.location.address.state": string;
            readonly "sort.location.address.state": components["schemas"]["SortDirection"];
            readonly "filter.location.distance": string;
            readonly "sort.location.distance": components["schemas"]["SortDirection"];
            readonly "filter.location.Id": string;
            readonly "sort.location.Id": components["schemas"]["SortDirection"];
            readonly "filter.date.timeOfDay": string;
            readonly "sort.date.timeOfDay": components["schemas"]["SortDirection"];
            readonly "filter.date.dayOfWeek": string;
            readonly "sort.date.dayOfWeek": components["schemas"]["SortDirection"];
        };
        /** Query<Clinic> */
        readonly "Query<Clinic>": {
            /**
             * Format: int32
             * @default 1
             */
            readonly Page: number;
            /**
             * Format: int32
             * @default 100
             */
            readonly PageSize: number;
            readonly "filter.Location.BrandName": string;
            readonly "filter.Location.Id": string;
            readonly "filter.Location.Name": string;
            readonly "filter.Location.SuppressFromWebsite": string;
            readonly "filter.Location.ModifiedAt": string;
            readonly "filter.Location.CreatedAt": string;
            readonly "filter.Location.CreatedBy": string;
            readonly "filter.Location": string;
            readonly "sort.Location": components["schemas"]["SortDirection"];
            readonly "filter.Attributes.SupportsTherapy": string;
            readonly "filter.Attributes.SupportsMedMgmt": string;
            readonly "filter.Attributes.HasEsketamine": string;
            readonly "filter.Attributes.HasTms": string;
            readonly "filter.Attributes.HasFlex": string;
            readonly "filter.Attributes.HasGroupTherapy": string;
            readonly "filter.Attributes": string;
            readonly "sort.Attributes": components["schemas"]["SortDirection"];
            readonly "filter.Email": string;
            readonly "sort.Email": components["schemas"]["SortDirection"];
            readonly "filter.Url": string;
            readonly "sort.Url": components["schemas"]["SortDirection"];
            readonly "filter.DescriptionHtml": string;
            readonly "sort.DescriptionHtml": components["schemas"]["SortDirection"];
            readonly "filter.CreatedAt": string;
            readonly "sort.CreatedAt": components["schemas"]["SortDirection"];
            readonly "filter.CreatedBy": string;
            readonly "sort.CreatedBy": components["schemas"]["SortDirection"];
            readonly "filter.ModifiedAt": string;
            readonly "sort.ModifiedAt": components["schemas"]["SortDirection"];
            readonly "filter.SuppressFromWebsite": string;
            readonly "sort.SuppressFromWebsite": components["schemas"]["SortDirection"];
        };
        /** Query<ClinicianAvailabilityInfo> */
        readonly "Query<ClinicianAvailabilityInfo>": {
            /**
             * Format: int32
             * @default 1
             */
            readonly Page: number;
            /**
             * Format: int32
             * @default 100
             */
            readonly PageSize: number;
            readonly "filter.Clinician": string;
            readonly "sort.Clinician": components["schemas"]["SortDirection"];
            readonly "filter.Location.LocationId": string;
            readonly "filter.Location.Address.State": string;
            readonly "filter.Location.distance": string;
            readonly "sort.Location.distance": components["schemas"]["SortDirection"];
            readonly "filter.Location": string;
            readonly "sort.Location": components["schemas"]["SortDirection"];
            readonly "filter.Days.Date": string;
            readonly "filter.Days.DayOfWeek": string;
            readonly "filter.Days.Slots.Time": string;
            readonly "filter.Days.Slots.TimeOfDay": string;
            readonly "filter.Days.Slots.Duration": string;
            readonly "filter.Days.Slots.Setting": string;
            readonly "filter.Days.Slots": string;
            readonly "filter.Days": string;
            readonly "sort.Days": components["schemas"]["SortDirection"];
            readonly "filter.Clinician.gender": string;
            readonly "sort.Clinician.gender": components["schemas"]["SortDirection"];
            readonly "filter.Clinician.language": string;
            readonly "sort.Clinician.language": components["schemas"]["SortDirection"];
            readonly "filter.Clinician.npi": string;
            readonly "sort.Clinician.npi": components["schemas"]["SortDirection"];
            readonly "filter.Clinician.type": string;
            readonly "sort.Clinician.type": components["schemas"]["SortDirection"];
            readonly "filter.Clinician.supportedConditions": string;
            readonly "sort.Clinician.supportedConditions": components["schemas"]["SortDirection"];
            readonly "filter.Clinician.acceptedInsurance": string;
            readonly "sort.Clinician.acceptedInsurance": components["schemas"]["SortDirection"];
            readonly "filter.Clinician.acceptedInsurancePlans": string;
            readonly "sort.Clinician.acceptedInsurancePlans": components["schemas"]["SortDirection"];
            readonly "filter.Clinician.AgeRange": string;
            readonly "sort.Clinician.AgeRange": components["schemas"]["SortDirection"];
            readonly "filter.Clinician.id": string;
            readonly "sort.Clinician.id": components["schemas"]["SortDirection"];
        };
        /** Query<ClinicianGeneralInfo> */
        readonly "Query<ClinicianGeneralInfo>": {
            /**
             * Format: int32
             * @default 1
             */
            readonly Page: number;
            /**
             * Format: int32
             * @default 100
             */
            readonly PageSize: number;
            readonly "filter.NpiNumber": string;
            readonly "sort.NpiNumber": components["schemas"]["SortDirection"];
            readonly "filter.CreatedAt": string;
            readonly "sort.CreatedAt": components["schemas"]["SortDirection"];
            readonly "filter.ModifiedAt": string;
            readonly "sort.ModifiedAt": components["schemas"]["SortDirection"];
            readonly "filter.ModifiedBy": string;
            readonly "sort.ModifiedBy": components["schemas"]["SortDirection"];
            readonly "filter.ContactDetails.FirstName": string;
            readonly "filter.ContactDetails.LastName": string;
            readonly "filter.Credentials": string;
            readonly "sort.Credentials": components["schemas"]["SortDirection"];
            readonly "filter.Title": string;
            readonly "sort.Title": components["schemas"]["SortDirection"];
            readonly "filter.Gender": string;
            readonly "sort.Gender": components["schemas"]["SortDirection"];
            readonly "filter.CredentialedDate": string;
            readonly "sort.CredentialedDate": components["schemas"]["SortDirection"];
            readonly "filter.StartDate": string;
            readonly "sort.StartDate": components["schemas"]["SortDirection"];
            readonly "filter.EndDate": string;
            readonly "sort.EndDate": components["schemas"]["SortDirection"];
            readonly "filter.DateOfBirth": string;
            readonly "sort.DateOfBirth": components["schemas"]["SortDirection"];
            readonly "filter.Active": string;
            readonly "sort.Active": components["schemas"]["SortDirection"];
            readonly "filter.AllowedInOnlineScheduling": string;
            readonly "sort.AllowedInOnlineScheduling": components["schemas"]["SortDirection"];
            readonly "filter.Education": string;
            readonly "sort.Education": components["schemas"]["SortDirection"];
            readonly "filter.ReviewStats.Average": string;
            readonly "filter.ReviewStats": string;
            readonly "sort.ReviewStats": components["schemas"]["SortDirection"];
            readonly "filter.AgeRange.Min": string;
            readonly "filter.AgeRange.Max": string;
            readonly "filter.AgeRange": string;
            readonly "sort.AgeRange": components["schemas"]["SortDirection"];
        };
        /** Query<ClinicianLocationInfo> */
        readonly "Query<ClinicianLocationInfo>": {
            /**
             * Format: int32
             * @default 1
             */
            readonly Page: number;
            /**
             * Format: int32
             * @default 100
             */
            readonly PageSize: number;
            readonly "filter.IsPrimaryLocation": string;
            readonly "sort.IsPrimaryLocation": components["schemas"]["SortDirection"];
            readonly "filter.IsCredentialed": string;
            readonly "sort.IsCredentialed": components["schemas"]["SortDirection"];
            readonly "filter.IsTreating": string;
            readonly "sort.IsTreating": components["schemas"]["SortDirection"];
            readonly "filter.StartDate": string;
            readonly "sort.StartDate": components["schemas"]["SortDirection"];
            readonly "filter.EndDate": string;
            readonly "sort.EndDate": components["schemas"]["SortDirection"];
            readonly "sort.LocationId": components["schemas"]["SortDirection"];
            readonly "filter.SuppressFromWebsite": string;
            readonly "sort.SuppressFromWebsite": components["schemas"]["SortDirection"];
        };
        /** Query<Condition> */
        readonly "Query<Condition>": {
            /**
             * Format: int32
             * @default 1
             */
            readonly Page: number;
            /**
             * Format: int32
             * @default 100
             */
            readonly PageSize: number;
            readonly "filter.Id": string;
            readonly "filter.Name": string;
            readonly "sort.Name": components["schemas"]["SortDirection"];
            readonly "filter.Description": string;
            readonly "sort.Description": components["schemas"]["SortDirection"];
            readonly "filter.ForTherapy": string;
            readonly "sort.ForTherapy": components["schemas"]["SortDirection"];
            readonly "filter.ForPrescriber": string;
            readonly "sort.ForPrescriber": components["schemas"]["SortDirection"];
            readonly "filter.IsTherapyDefault": string;
            readonly "sort.IsTherapyDefault": components["schemas"]["SortDirection"];
            readonly "filter.IsPrescriberDefault": string;
            readonly "sort.IsPrescriberDefault": components["schemas"]["SortDirection"];
            readonly "filter.InOnlineScheduling": string;
            readonly "sort.InOnlineScheduling": components["schemas"]["SortDirection"];
            readonly "filter.SortOrder": string;
            readonly "sort.SortOrder": components["schemas"]["SortDirection"];
            readonly "filter.IsDeleted": string;
            readonly "sort.IsDeleted": components["schemas"]["SortDirection"];
            readonly "filter.CreatedAt": string;
            readonly "sort.CreatedAt": components["schemas"]["SortDirection"];
            readonly "filter.CreatedBy": string;
            readonly "sort.CreatedBy": components["schemas"]["SortDirection"];
            readonly "filter.ModifiedAt": string;
            readonly "sort.ModifiedAt": components["schemas"]["SortDirection"];
            readonly "filter.ModifiedBy": string;
            readonly "sort.ModifiedBy": components["schemas"]["SortDirection"];
            readonly "filter.clinicians.npinumber": string;
            readonly "sort.clinicians.npinumber": components["schemas"]["SortDirection"];
        };
        /** Query<DetailedInsurance> */
        readonly "Query<DetailedInsurance>": {
            /**
             * Format: int32
             * @default 1
             */
            readonly Page: number;
            /**
             * Format: int32
             * @default 100
             */
            readonly PageSize: number;
            readonly "filter.Plans.Id": string;
            readonly "filter.Plans.InsuranceId": string;
            readonly "filter.Plans.Name": string;
            readonly "filter.Plans.State": string;
            readonly "filter.Plans.ModifiedAt": string;
            readonly "filter.Plans.ModifiedBy": string;
            readonly "filter.Plans.IsDeleted": string;
            readonly "filter.Plans.CreatedAt": string;
            readonly "filter.Plans.CreatedBy": string;
            readonly "filter.Plans.insurance.name": string;
            readonly "sort.Plans.insurance.name": components["schemas"]["SortDirection"];
            readonly "filter.Plans": string;
            readonly "sort.Plans": components["schemas"]["SortDirection"];
            readonly "filter.Id": string;
            readonly "filter.Name": string;
            readonly "sort.Name": components["schemas"]["SortDirection"];
            readonly "filter.IsTopInsurer": string;
            readonly "sort.IsTopInsurer": components["schemas"]["SortDirection"];
            readonly "filter.ModifiedAt": string;
            readonly "sort.ModifiedAt": components["schemas"]["SortDirection"];
            readonly "filter.ModifiedBy": string;
            readonly "sort.ModifiedBy": components["schemas"]["SortDirection"];
            readonly "filter.IsDeleted": string;
            readonly "sort.IsDeleted": components["schemas"]["SortDirection"];
            readonly "filter.CreatedAt": string;
            readonly "sort.CreatedAt": components["schemas"]["SortDirection"];
            readonly "filter.CreatedBy": string;
            readonly "sort.CreatedBy": components["schemas"]["SortDirection"];
            readonly "filter.clinicians.npinumber": string;
            readonly "sort.clinicians.npinumber": components["schemas"]["SortDirection"];
            readonly "filter.state": string;
            readonly "sort.state": components["schemas"]["SortDirection"];
        };
        /** Query<Insurance> */
        readonly "Query<Insurance>": {
            /**
             * Format: int32
             * @default 1
             */
            readonly Page: number;
            /**
             * Format: int32
             * @default 100
             */
            readonly PageSize: number;
            readonly "filter.Id": string;
            readonly "filter.Name": string;
            readonly "sort.Name": components["schemas"]["SortDirection"];
            readonly "filter.IsTopInsurer": string;
            readonly "sort.IsTopInsurer": components["schemas"]["SortDirection"];
            readonly "filter.ModifiedAt": string;
            readonly "sort.ModifiedAt": components["schemas"]["SortDirection"];
            readonly "filter.ModifiedBy": string;
            readonly "sort.ModifiedBy": components["schemas"]["SortDirection"];
            readonly "filter.IsDeleted": string;
            readonly "sort.IsDeleted": components["schemas"]["SortDirection"];
            readonly "filter.CreatedAt": string;
            readonly "sort.CreatedAt": components["schemas"]["SortDirection"];
            readonly "filter.CreatedBy": string;
            readonly "sort.CreatedBy": components["schemas"]["SortDirection"];
            readonly "filter.clinicians.npinumber": string;
            readonly "sort.clinicians.npinumber": components["schemas"]["SortDirection"];
            readonly "filter.state": string;
            readonly "sort.state": components["schemas"]["SortDirection"];
        };
        /** Query<InsurancePlan> */
        readonly "Query<InsurancePlan>": {
            /**
             * Format: int32
             * @default 1
             */
            readonly Page: number;
            /**
             * Format: int32
             * @default 100
             */
            readonly PageSize: number;
            readonly "filter.Id": string;
            readonly "filter.InsuranceId": string;
            readonly "sort.InsuranceId": components["schemas"]["SortDirection"];
            readonly "filter.Name": string;
            readonly "sort.Name": components["schemas"]["SortDirection"];
            readonly "filter.State": string;
            readonly "sort.State": components["schemas"]["SortDirection"];
            readonly "filter.ModifiedAt": string;
            readonly "sort.ModifiedAt": components["schemas"]["SortDirection"];
            readonly "filter.ModifiedBy": string;
            readonly "sort.ModifiedBy": components["schemas"]["SortDirection"];
            readonly "filter.IsDeleted": string;
            readonly "sort.IsDeleted": components["schemas"]["SortDirection"];
            readonly "filter.CreatedAt": string;
            readonly "sort.CreatedAt": components["schemas"]["SortDirection"];
            readonly "filter.CreatedBy": string;
            readonly "sort.CreatedBy": components["schemas"]["SortDirection"];
            readonly "filter.insurance.name": string;
            readonly "sort.insurance.name": components["schemas"]["SortDirection"];
        };
        /** Query<Metadata> */
        readonly "Query<Metadata>": {
            /**
             * Format: int32
             * @default 1
             */
            readonly Page: number;
            /**
             * Format: int32
             * @default 100
             */
            readonly PageSize: number;
            readonly "filter.Category": string;
            readonly "sort.Category": components["schemas"]["SortDirection"];
            readonly "filter.Name": string;
            readonly "sort.Name": components["schemas"]["SortDirection"];
            readonly "filter.DataType": string;
            readonly "sort.DataType": components["schemas"]["SortDirection"];
            readonly "filter.IsRequired": string;
            readonly "sort.IsRequired": components["schemas"]["SortDirection"];
            readonly "filter.IsDeleted": string;
            readonly "sort.IsDeleted": components["schemas"]["SortDirection"];
            readonly "filter.Notes": string;
            readonly "sort.Notes": components["schemas"]["SortDirection"];
            readonly "filter.CreatedAt": string;
            readonly "sort.CreatedAt": components["schemas"]["SortDirection"];
            readonly "filter.CreatedBy": string;
            readonly "sort.CreatedBy": components["schemas"]["SortDirection"];
            readonly "filter.ModifiedAt": string;
            readonly "sort.ModifiedAt": components["schemas"]["SortDirection"];
            readonly "filter.ModifiedBy": string;
            readonly "sort.ModifiedBy": components["schemas"]["SortDirection"];
        };
        /** Query<Patient> */
        readonly "Query<Patient>": {
            /**
             * Format: int32
             * @default 1
             */
            readonly Page: number;
            /**
             * Format: int32
             * @default 100
             */
            readonly PageSize: number;
            readonly "filter.ExternalId": string;
            readonly "sort.CreatedAt": components["schemas"]["SortDirection"];
            readonly "filter.DateOfBirth": string;
            readonly "sort.DateOfBirth": components["schemas"]["SortDirection"];
            readonly "filter.SexAtBirth": string;
            readonly "sort.SexAtBirth": components["schemas"]["SortDirection"];
            readonly "filter.PrimaryAddress.Address1": string;
            readonly "filter.PrimaryAddress.Address2": string;
            readonly "filter.PrimaryAddress.City": string;
            readonly "filter.PrimaryAddress.State": string;
            readonly "filter.PrimaryAddress.Zip": string;
            readonly "filter.PrimaryAddress": string;
            readonly "sort.PrimaryAddress": components["schemas"]["SortDirection"];
            readonly "filter.ContactDetails.FirstName": string;
            readonly "sort.ContactDetails.FirstName": components["schemas"]["SortDirection"];
            readonly "filter.ContactDetails.LastName": string;
            readonly "sort.ContactDetails.LastName": components["schemas"]["SortDirection"];
            readonly "filter.ContactDetails.HomePhone": string;
            readonly "sort.ContactDetails.HomePhone": components["schemas"]["SortDirection"];
            readonly "filter.ContactDetails.MobilePhone": string;
            readonly "sort.ContactDetails.MobilePhone": components["schemas"]["SortDirection"];
            readonly "filter.ContactDetails.WorkPhone": string;
            readonly "sort.ContactDetails.WorkPhone": components["schemas"]["SortDirection"];
            readonly "filter.ContactDetails.Email": string;
            readonly "sort.ContactDetails.Email": components["schemas"]["SortDirection"];
        };
        /** Query<Review> */
        readonly "Query<Review>": {
            /**
             * Format: int32
             * @default 1
             */
            readonly Page: number;
            /**
             * Format: int32
             * @default 100
             */
            readonly PageSize: number;
            readonly "filter.Id": string;
            readonly "sort.TargetId": components["schemas"]["SortDirection"];
            readonly "filter.TargetType": string;
            readonly "sort.TargetType": components["schemas"]["SortDirection"];
            readonly "filter.Approver": string;
            readonly "sort.Approver": components["schemas"]["SortDirection"];
            readonly "filter.ModifiedAt": string;
            readonly "sort.ModifiedAt": components["schemas"]["SortDirection"];
            readonly "filter.ModifiedBy": string;
            readonly "sort.ModifiedBy": components["schemas"]["SortDirection"];
            readonly "filter.IsDeleted": string;
            readonly "sort.IsDeleted": components["schemas"]["SortDirection"];
            readonly "filter.CreatedAt": string;
            readonly "sort.CreatedAt": components["schemas"]["SortDirection"];
            readonly "filter.CreatedBy": string;
            readonly "sort.CreatedBy": components["schemas"]["SortDirection"];
        };
        readonly ReasonInfo: {
            /** Format: int32 */
            readonly conditionId: number;
            readonly reasonType: components["schemas"]["ReasonType"];
        };
        /** @enum {string} */
        readonly ReasonType: ReasonType;
        /** @enum {string} */
        readonly ResourceType: ResourceType;
        readonly Review: {
            /** Format: int32 */
            readonly id: number;
            /** Format: int32 */
            readonly targetId: number;
            readonly targetType: components["schemas"]["Target"];
            readonly originalReview: string;
            readonly approvedReview: string | null;
            readonly approver: string | null;
            /** Format: date-time */
            readonly modifiedAt: string | null;
            readonly modifiedBy: string | null;
            readonly isDeleted?: boolean;
            /** Format: date-time */
            readonly createdAt: string;
            readonly createdBy: string;
        };
        readonly ReviewIQueryResult: {
            /** Format: int32 */
            readonly totalCount: number;
            /** Format: int32 */
            readonly totalPages: number;
            /** Format: int32 */
            readonly currentPage: number;
            /** Format: int32 */
            readonly itemsInPageCount: number;
            readonly hasMore: boolean;
            readonly items: readonly components["schemas"]["Review"][];
        };
        readonly ReviewStats: {
            /** Format: int32 */
            readonly count: number;
            /** Format: double */
            readonly average: number;
        };
        /** @enum {string} */
        readonly SortDirection: SortDirection;
        /** @enum {string} */
        readonly State: State;
        /** @enum {string} */
        readonly Target: Target;
        /** @enum {string} */
        readonly TimeOfDay: TimeOfDay;
        readonly TimeSlot: {
            readonly externalSlotId?: string | null;
            /** Format: time */
            readonly time: string;
            readonly timeOfDay: components["schemas"]["TimeOfDay"];
            /** Format: int32 */
            readonly duration: number;
            readonly setting: components["schemas"]["AppointmentSettingType"];
        };
        /** @enum {string} */
        readonly Type: Type;
        readonly ValidationProblemDetails: {
            readonly type: string | null;
            readonly title: string | null;
            /** Format: int32 */
            readonly status: number | null;
            readonly detail: string | null;
            readonly instance: string | null;
            readonly errors: Readonly<Record<string, readonly string[]>>;
        } & Readonly<Record<string, unknown>>;
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type SchemaAddress = components['schemas']['Address'];
export type SchemaAddressContact = components['schemas']['AddressContact'];
export type SchemaAppointmentGeneralInfo = components['schemas']['AppointmentGeneralInfo'];
export type SchemaAppointmentGeneralInfoIQueryResult = components['schemas']['AppointmentGeneralInfoIQueryResult'];
export type SchemaAppointmentSettingType = components['schemas']['AppointmentSettingType'];
export type SchemaAppointmentStatus = components['schemas']['AppointmentStatus'];
export type SchemaAttachmentExposedInfo = components['schemas']['AttachmentExposedInfo'];
export type SchemaAttachmentExposedInfoIExposedIntakeRequestInfo = components['schemas']['AttachmentExposedInfoIExposedIntakeRequestInfo'];
export type SchemaAvailableAppointment = components['schemas']['AvailableAppointment'];
export type SchemaAvailableAppointmentForInfo = components['schemas']['AvailableAppointmentForInfo'];
export type SchemaAvailableAppointmentForInfoIQueryResult = components['schemas']['AvailableAppointmentForInfoIQueryResult'];
export type SchemaAvailableAppointmentIQueryResult = components['schemas']['AvailableAppointmentIQueryResult'];
export type SchemaBookingStatusType = components['schemas']['BookingStatusType'];
export type SchemaBusinessHours = components['schemas']['BusinessHours'];
export type SchemaCheckInitializedIntakeRequest = components['schemas']['CheckInitializedIntakeRequest'];
export type SchemaClinic = components['schemas']['Clinic'];
export type SchemaClinicIQueryResult = components['schemas']['ClinicIQueryResult'];
export type SchemaClinicalLocationAttributes = components['schemas']['ClinicalLocationAttributes'];
export type SchemaClinicianAvailabilityInfo = components['schemas']['ClinicianAvailabilityInfo'];
export type SchemaClinicianAvailabilityInfoIQueryResult = components['schemas']['ClinicianAvailabilityInfoIQueryResult'];
export type SchemaClinicianDetailedInfo = components['schemas']['ClinicianDetailedInfo'];
export type SchemaClinicianGeneralInfo = components['schemas']['ClinicianGeneralInfo'];
export type SchemaClinicianGeneralInfoIQueryResult = components['schemas']['ClinicianGeneralInfoIQueryResult'];
export type SchemaClinicianInfo = components['schemas']['ClinicianInfo'];
export type SchemaClinicianLocationInfo = components['schemas']['ClinicianLocationInfo'];
export type SchemaClinicianLocationMetadata = components['schemas']['ClinicianLocationMetadata'];
export type SchemaClinicianType = components['schemas']['ClinicianType'];
export type SchemaCondition = components['schemas']['Condition'];
export type SchemaConditionIQueryResult = components['schemas']['ConditionIQueryResult'];
export type SchemaContactDetails = components['schemas']['ContactDetails'];
export type SchemaContactType = components['schemas']['ContactType'];
export type SchemaCoordinates = components['schemas']['Coordinates'];
export type SchemaCreatePatientReq = components['schemas']['CreatePatientReq'];
export type SchemaDay = components['schemas']['Day'];
export type SchemaDaySlot = components['schemas']['DaySlot'];
export type SchemaDetailedInsurance = components['schemas']['DetailedInsurance'];
export type SchemaDetailedInsuranceIQueryResult = components['schemas']['DetailedInsuranceIQueryResult'];
export type SchemaEmailContact = components['schemas']['EmailContact'];
export type SchemaFinalizedIntakeRequestInfo = components['schemas']['FinalizedIntakeRequestInfo'];
export type SchemaGender = components['schemas']['Gender'];
export type SchemaIContactable = components['schemas']['IContactable'];
export type SchemaIExposedIntakeRequestInfo = components['schemas']['IExposedIntakeRequestInfo'];
export type SchemaInsurance = components['schemas']['Insurance'];
export type SchemaInsuranceIQueryResult = components['schemas']['InsuranceIQueryResult'];
export type SchemaInsuranceInfo = components['schemas']['InsuranceInfo'];
export type SchemaInsurancePlan = components['schemas']['InsurancePlan'];
export type SchemaInsurancePlanIQueryResult = components['schemas']['InsurancePlanIQueryResult'];
export type SchemaInt32RangedValue = components['schemas']['Int32RangedValue'];
export type SchemaIntakeAppointmentInfo = components['schemas']['IntakeAppointmentInfo'];
export type SchemaIntakeAttachmentSide = components['schemas']['IntakeAttachmentSide'];
export type SchemaIntakeInitializationRequest = components['schemas']['IntakeInitializationRequest'];
export type SchemaIntakePatientReq = components['schemas']['IntakePatientReq'];
export type SchemaLocation = components['schemas']['Location'];
export type SchemaLocationIQueryResult = components['schemas']['LocationIQueryResult'];
export type SchemaLocationInfo = components['schemas']['LocationInfo'];
export type SchemaLocationType = components['schemas']['LocationType'];
export type SchemaMetadata = components['schemas']['Metadata'];
export type SchemaNotFoundResult = components['schemas']['NotFoundResult'];
export type SchemaNotificationType = components['schemas']['NotificationType'];
export type SchemaOldTenUpLocationInfo = components['schemas']['OldTenUpLocationInfo'];
export type SchemaPatient = components['schemas']['Patient'];
export type SchemaPatientBase = components['schemas']['PatientBase'];
export type SchemaPatientIQueryResult = components['schemas']['PatientIQueryResult'];
export type SchemaPhoneContact = components['schemas']['PhoneContact'];
export type SchemaPhoneType = components['schemas']['PhoneType'];
export type SchemaProblemDetails = components['schemas']['ProblemDetails'];
export type SchemaQueryAppointmentGeneralInfo = components['schemas']['Query<AppointmentGeneralInfo>'];
export type SchemaQueryAvailableAppointment = components['schemas']['Query<AvailableAppointment>'];
export type SchemaQueryClinic = components['schemas']['Query<Clinic>'];
export type SchemaQueryClinicianAvailabilityInfo = components['schemas']['Query<ClinicianAvailabilityInfo>'];
export type SchemaQueryClinicianGeneralInfo = components['schemas']['Query<ClinicianGeneralInfo>'];
export type SchemaQueryClinicianLocationInfo = components['schemas']['Query<ClinicianLocationInfo>'];
export type SchemaQueryCondition = components['schemas']['Query<Condition>'];
export type SchemaQueryDetailedInsurance = components['schemas']['Query<DetailedInsurance>'];
export type SchemaQueryInsurance = components['schemas']['Query<Insurance>'];
export type SchemaQueryInsurancePlan = components['schemas']['Query<InsurancePlan>'];
export type SchemaQueryMetadata = components['schemas']['Query<Metadata>'];
export type SchemaQueryPatient = components['schemas']['Query<Patient>'];
export type SchemaQueryReview = components['schemas']['Query<Review>'];
export type SchemaReasonInfo = components['schemas']['ReasonInfo'];
export type SchemaReasonType = components['schemas']['ReasonType'];
export type SchemaResourceType = components['schemas']['ResourceType'];
export type SchemaReview = components['schemas']['Review'];
export type SchemaReviewIQueryResult = components['schemas']['ReviewIQueryResult'];
export type SchemaReviewStats = components['schemas']['ReviewStats'];
export type SchemaSortDirection = components['schemas']['SortDirection'];
export type SchemaState = components['schemas']['State'];
export type SchemaTarget = components['schemas']['Target'];
export type SchemaTimeOfDay = components['schemas']['TimeOfDay'];
export type SchemaTimeSlot = components['schemas']['TimeSlot'];
export type SchemaType = components['schemas']['Type'];
export type SchemaValidationProblemDetails = components['schemas']['ValidationProblemDetails'];
export type $defs = Record<string, never>;
export enum AppointmentSettingType {
    None = "None",
    InPerson = "InPerson",
    Telehealth = "Telehealth",
    Hybrid = "Hybrid"
}
export enum AppointmentStatus {
    None = "None",
    Scheduled = "Scheduled",
    Other = "Other",
    Completed = "Completed",
    ReScheduled = "ReScheduled",
    Cancelled = "Cancelled",
    Deleted = "Deleted",
    NoShow = "NoShow"
}
export enum BookingStatusType {
    OkayToSchedule = 1,
    DoNotSchedule = 2,
    NeedsVerification = 3,
    PleaseVerifyDelayToInsDetails = 4,
    CashSelfPay = 5,
}
export enum ClinicianType {
    None = "None",
    InpatientOnlyProvider = "InpatientOnlyProvider",
    Prescriber = "Prescriber",
    Therapist = "Therapist",
    Paraprofessional = "Paraprofessional",
    ABA = "ABA",
    AssociateProvisionallyLicensedProvider = "AssociateProvisionallyLicensedProvider"
}
export enum ContactType {
    Email = "Email",
    Phone = "Phone",
    Address = "Address"
}
export enum Day {
    None = "None",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
    Sunday = "Sunday"
}
export enum Gender {
    None = "None",
    Male = "Male",
    Female = "Female",
    NonBinary = "NonBinary"
}
export enum IntakeAttachmentSide {
    None = "None",
    Front = "Front",
    Back = "Back"
}
export enum LocationType {
    None = "None",
    Clinic = "Clinic",
    Unknown = "Unknown"
}
export enum NotificationType {
    None = "None",
    Sms = "Sms",
    Phone = "Phone",
    Email = "Email",
    SnailMail = "SnailMail",
    App = "App"
}
export enum PhoneType {
    Other = "Other",
    Home = "Home",
    Work = "Work",
    Mobile = "Mobile",
    Fax = "Fax"
}
export enum ReasonType {
    None = "None",
    Therapy = "Therapy",
    Psychiatry = "Psychiatry"
}
export enum ResourceType {
    Clinicians = "Clinicians",
    Clinics = "Clinics",
    Insurances = "Insurances",
    Reviews = "Reviews",
    Availability = "Availability"
}
export enum SortDirection {
    Asc = "Asc",
    Desc = "Desc"
}
export enum State {
    None = "None",
    AL = "AL",
    AK = "AK",
    AZ = "AZ",
    AR = "AR",
    CA = "CA",
    CO = "CO",
    CT = "CT",
    DE = "DE",
    DC = "DC",
    FL = "FL",
    GA = "GA",
    HI = "HI",
    ID = "ID",
    IL = "IL",
    IN = "IN",
    IA = "IA",
    KS = "KS",
    KY = "KY",
    LA = "LA",
    ME = "ME",
    MD = "MD",
    MA = "MA",
    MI = "MI",
    MN = "MN",
    MS = "MS",
    MO = "MO",
    MT = "MT",
    NE = "NE",
    NV = "NV",
    NH = "NH",
    NJ = "NJ",
    NM = "NM",
    NY = "NY",
    NC = "NC",
    ND = "ND",
    OH = "OH",
    OK = "OK",
    OR = "OR",
    PA = "PA",
    RI = "RI",
    SC = "SC",
    SD = "SD",
    TN = "TN",
    TX = "TX",
    UT = "UT",
    VT = "VT",
    VA = "VA",
    WA = "WA",
    WV = "WV",
    WI = "WI",
    WY = "WY"
}
export enum Target {
    None = "None",
    Location = "Location",
    Clinician = "Clinician"
}
export enum TimeOfDay {
    None = "None",
    Morning = "Morning",
    Afternoon = "Afternoon"
}
export enum Type {
    Text = "Text",
    Int = "Int",
    Decimal = "Decimal",
    DateTime = "DateTime",
    Bit = "Bit"
}
export type operations = Record<string, never>;
